const { size } = require('../size')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {array} values
 * @param {array} exclude
 * @returns {array|undefined}
 */
function formatBanks (values, exclude = []) {
  if (!size(values)) return []

  return values
    .filter(item => !exclude.includes(item?.id))
    .map(({ id, value, clearingRanges, tinkIdentifier }) => {
      return {
        value: id,
        label: value,
        tinkIdentifier,
        clearingRanges
      }
    })
}

module.exports = { formatBanks }
